import fetch from 'services/request';
import { IApiUpdateTicketBody, IApiVoidOpenTicketBody } from './types/ticket';
import { IApiCashierPaymentBody, IApiMultipleCardsPaymentBody } from './types/payment';
import { IApiMergeBillBody, IApiSplitBillBody } from './types/bill';
import { ICashDepositItem } from './types/deposit';

const cashierApis = {
  newTicket: () => fetch({
    url: '/api/v1/bill/new-ticket',
  }),
  lstBillOnHold: () => fetch({
    url: '/api/v1/bill/list-on-hold',
  }),
  products: (categoryId: string) => fetch({
    url: `/api/v1/product/list-by-category/${categoryId}`,
  }),
  searchProducts: (keySearch: string) => fetch({
    url: '/api/v1/product/search',
    params: { keySearch },
  }),
  updateTicket: (body: IApiUpdateTicketBody) => fetch({
    url: '/api/v1/bill/update-ticket',
    method: 'post',
    body,
  }),
  voidOpenTicket: (body: IApiVoidOpenTicketBody) => fetch({
    url: '/api/v1/payment/voided-ticket',
    method: 'post',
    body,
  }),
  getGiftCardInfo: (giftCode: string) => fetch({
    url: '/api/v1/gift-card/get-by-code',
    params: { giftCode }
  }),
  getBillById: (billId: string) => fetch({
    url: `/api/v1/bill/detail/${billId}`,
  }),
  getCouponByCode: (code: string) => fetch({
    url: '/api/v1/coupon/get-by-code',
    params: { code },
  }),
  paymentTicket: (body: IApiCashierPaymentBody) => fetch({
    method: 'post',
    url: '/api/v1/payment',
    body,
  }),
  updateSignature: (billId: string, signature: string) => fetch({
    method: 'post',
    url: '/api/v1/payment/update-signature',
    body: { billId, signature }
  }),
  sendSMSEmailReceipt: (billId: string, type: 'SMS' | 'EMAIL', signatureValue: string) => {
    return fetch({
      method: 'post',
      url: 'api/v1/payment/send-sms-email-receipt',
      body: {
        billId: billId,
        value: signatureValue,
        type,
      },
    });
  },
  paymentMultipleCards: (body: IApiMultipleCardsPaymentBody) => fetch({
    method: 'post',
    url: '/api/v1/payment/multiple-card',
    body,
  }),
  updateSignatureForCreditCard: (id: string, signature: string) => fetch({
    method: 'post',
    url: '/api/v1/payment/update-signature-multiple-card',
    body: {
      billId: id,
      signature,
    },
  }),
  getListMultipleCards: (billId: string) => fetch({
    method: 'get',
    url: `/api/v1/payment/multiple-card/${billId}`,
  }),
  getCouponPrint: (billId: string) => fetch({
    method: 'get',
    url: 'api/v1/coupon/list-print/' + billId,
  }),
  getNumberTicket: () => fetch({
    method: 'get',
    url: 'api/v1/bill/get-number-ticket',
  }),
  getStaffWorking: () => fetch({
    method: 'get',
    url: 'api/v1/staff/working',
  }),
  deleteMultipleBill: (body: string[]) => fetch({
    method: 'post',
    url: 'api/v1/bill/delete-multiple',
    body,
  }),
  getProductByCode: (keySearch: string) => fetch({
    method: 'get',
    url: '/api/v1/product/search',
    params: { keySearch }
  }),
  splitTicket: (body: IApiSplitBillBody) => fetch({
    method: 'post',
    url: '/api/v1/bill/split-ticket',
    body,
  }),
  mergeTicket: (body: IApiMergeBillBody) => fetch({
    method: 'post',
    url: '/api/v1/bill/merge-ticket',
    body,
  }),
  cashDeposit: () => fetch({ method: 'get', url: '/api/v1/store/cash-deposit' }),
  updateCashDeposit: (body: ICashDepositItem[]) => fetch({ method: 'post', url: '/api/v1/store/cash-deposit', body }),
  getPromotions: () => fetch({ method: 'get', url: '/api/v1/product/list-by-promotion' }),
  getCustomerDetail: (customerId: string) => fetch({ method: 'get', url: `/api/v1/customer/detail/${customerId}` }),
};

export default cashierApis;
